// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"432711f8","425":"d53fa046","510":"6fcedda1","532":"414d80e7","633":"a0ebb79d","634":"548f03d7","922":"2eaae0a8","937":"be26bc35","972":"3efb93cc"}[chunkId] + ".chunk.js";
};